(() => {
  if (window.AugCartOperations) return;
  const pending = new Set();
  const waiters = new Set();
  let revision = 0;
  let snapshot = null;
  let blocked = null;
  const notify = () => document.dispatchEvent(new CustomEvent('aug:cart-operation', {
    detail: { pending: pending.size, revision },
  }));
  const settle = () => {
    if (pending.size) return;
    for (const waiter of waiters) blocked ? waiter.reject(blocked) : waiter.resolve();
    waiters.clear();
  };
  const fetchJSON = async (url, options = {}, timeout = 10000) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      const body = await response.json();
      if (!response.ok && (!body?.status || response.status >= 500)) {
        throw Object.assign(new Error('CART_HTTP_' + response.status), { code: 'HTTP_' + response.status });
      }
      return body;
    } finally {
      clearTimeout(timer);
    }
  };
  window.AugCartOperations = {
    begin() {
      const token = {};
      pending.add(token);
      revision += 1;
      notify();
      return token;
    },
    end(token) {
      if (!pending.delete(token)) return;
      revision += 1;
      notify();
      settle();
    },
    whenIdle() {
      if (!pending.size) return blocked ? Promise.reject(blocked) : Promise.resolve();
      return new Promise((resolve, reject) => waiters.add({ resolve, reject }));
    },
    getRevision: () => revision,
    getSnapshot: () => snapshot,
    setSnapshot(cart) {
      if (cart && Array.isArray(cart.items)) snapshot = cart;
    },
    block(error) { blocked = error instanceof Error ? error : new Error(String(error)); },
    clearBlock() { blocked = null; },
    fetchJSON,
    async fetchCart() {
      const cart = await fetchJSON(window.routes.cart_url + '.js', { cache: 'no-store' });
      if (!Array.isArray(cart?.items)) throw new Error('CART_INVALID_RESPONSE');
      snapshot = cart;
      return cart;
    },
  };
})();
